const coachRoutes = [
    // HOME
    {
        path: '/coach/home',
        name: 'coach.home',
        component: () => import('@/views/coach/Home'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
            rightPanel: 'HomeAgendaPanel',
        }
    },

    // COMPANY SIN PLAN (bloqueo coach_company)
    {
        path: '/coach/company-no-plan',
        name: 'coach.company-no-plan',
        component: () => import('@/views/coach/CompanyNoPlan'),
        meta: {}
    },

    // STUDENTS
    {
        path: '/coach/students',
        name: 'coach.students',
        component: () => import('@/views/coach/Students'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
            rightPanel: 'StudentsChatPanel',
        }
    },
    {
        path: '/coach/students/chats',
        name: 'coach.students.chats',
        component: () => import('@/views/coach/Chats'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/students/:uid',
        name: 'coach.students.profile',
        component: () => import('@/views/coach/StudentProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // LIBRARY
    {
        path: '/coach/library',
        name: 'coach.library',
        component: () => import('@/views/coach/Library'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ROUTINES
    {
        path: '/coach/routines/:uid',
        name: 'coach.routines.detail',
        component: () => import('@/views/coach/RoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid/edit',
        name: 'coach.routines.edit',
        component: () => import('@/views/coach/EditRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/:uid/edit/assigned',
        name: 'coach.routines.edit.assigned',
        component: () => import('@/views/coach/EditAssignedRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    // PROGRAMS
    {
        path: '/coach/routines/programs/:uid',
        name: 'coach.routines.program.detail',
        component: () => import('@/views/coach/ProgramDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/coach/routines/programs/:uid/routine/:id',
        name: 'coach.routines.program.detail.routine',
        component: () => import('@/views/coach/ProgramRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    // ZAPPING
    {
        path: '/coach/zapping',
        name: 'coach.zapping',
        component: () => import('@/views/coach/Zapping'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // CALENDAR
    {
        path: '/coach/calendar',
        name: 'coach.calendar',
        component: () => import('@/views/coach/Calendar'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/coach/calendar/:uid',
        name: 'coach.calendar.assignedRoutine',
        component: () => import('@/views/coach/AssignedRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // STATISTICS
    {
        path: '/coach/statistics',
        name: 'coach.statistics',
        component: () => import('@/views/coach/Statistics'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // PROFILE
    {
        path: '/coach/profile',
        name: 'coach.profile',
        component: () => import('@/views/coach/Profile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/coach/payment-method',
        name: 'coach.payment.edit',
        component: () => import('@/views/coach/PaymentMethod'),
        props: true,
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // EVALUATIONS
    {
        path: '/coach/evaluations',
        name: 'coach.evaluations',
        component: () => import('@/views/coach/Evaluations'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/coach/evaluations/statistics/:type/:id',
        name: 'coach.evaluations.statistics',
        component: () => import('@/views/coach/EvaluationsStatistics'),
        meta: {
            drawer: true,
            toolbar: true,
        },
    },

    // PAYMENT
    {
        path: '/coach/select-plan',
        name: 'coach.select-plan',
        component: () => import('@/views/coach/SelectPlan'),
    },
    {
        path: '/coach/credit-card',
        name: 'coach.credit-card',
        component: () => import('@/views/coach/CreditCard'),
    },
]

export default coachRoutes;